import React, { useContext, useState, PureComponent } from 'react'
import toast, { Toaster } from 'react-hot-toast';
import Input from '../components/forms/Input';
import Button from '../components/forms/Button';
import { initializeApp } from "firebase/app";
import { setToLocalStorage } from '../components/helper/auth'
import {
    GoogleAuthProvider,
    getAuth,
    signInWithPopup,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    sendPasswordResetEmail,
    signOut,
    sendEmailVerification,
} from "firebase/auth";
import {
    getFirestore,
    query,
    getDocs,
    collection,
    where,
    addDoc,
} from "firebase/firestore";
import { firebaseConfig } from "../firebaseConfig"
import { AuthContext } from '../context/auth';
import { useNavigate, Link } from 'react-router-dom';
import { doc, setDoc } from "firebase/firestore";

export default function DashBoard() {
    // Initialize Firebase
    const app = initializeApp(firebaseConfig);

    // Initialize Cloud Firestore and get a reference to the service
    const db = getFirestore(app);
    const [task, setTask] = useState("");
    const [postedBy, setPostedBy] = useState("");
    const createTask = async (e) => {
        const newTaskRef = doc(collection(db, "cities"));

        const data = {
            task,
            postedBy
        }
        await setDoc(newTaskRef, data);
    }
    return (
        <div className='d-flex justify-content-center align-items-center vh-100'>
            <Link className='btn btn-btn-outline-primary btn-lg' to={'/dashboard/tasks'}>
                Go to Task
            </Link>
        </div>

      
    )

}

